import { Button, Card, Col, DatePicker, Form, Input, Row, Select } from "antd";
import { useState } from "react";

function Taskindex(props: any) {
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  return (
    <div>
      {" "}
      <div>
        <Card>
          <Form
            onFinish={(val: any) => {
              setIsLoading(true);
              props.onFinish(val);
              setIsLoading(false);
              setIsLoadingButton(true);
            }}
            form={form}
            layout="vertical"
          >
            <Row gutter={16}>
              <Col sm={6}>
                <Form.Item name="Taskid" label="Taskid">
                  <Input placeholder="Enter Taskid" allowClear />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="TaskName" label="TaskName">
                  <Input placeholder="Enter TaskName" allowClear />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="startDates" label="startDate">
                  <DatePicker />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="endDates" label="endDate">
                  <DatePicker />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="hourss" label="hours">
                  <Input placeholder="Enter hours" allowClear />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="minituess" label="minitues">
                  <Input placeholder="Enter minitues" allowClear />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="prioritys" label="priority">
                  <Input placeholder="Enter priority" allowClear />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="descriptions" label="description">
                  <Input placeholder="Enter description" allowClear />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  name="status"
                  label="Status"
                  rules={[
                    { required: true, message: "Please select a status!" },
                  ]}
                >
                  <Select placeholder="Select Status">
                    <Select.Option value="pending">Pending</Select.Option>
                    <Select.Option value="inprogress">inprogress</Select.Option>
                    <Select.Option value="completed">Completed</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item>
              <Button
                size="large"
                loading={isLoadingButton}
                type="primary"
                htmlType="submit"
                block
              >
                Create Task
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
}

export default Taskindex;
